import { SendIvitationsRequest, SoggettoDto } from "@api/client";
import { idClienteSelector } from "common/_redux/company/selectors";
import { praticaIdPraticaSelector } from "common/_redux/pratica/selectors";
import {
	subjectGetDetails,
	subjectSendInvitation,
	subjectSetTitolariEffettiviAdded,
	subjectUpdateSubject,
} from "common/_redux/subject/actions";
import {
	elencoTitolariEffettiviSelector,
	subjectSubjectsSelector,
	titolariEffettiviAddedSelector,
} from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import MessageModal from "common/components/message-modal";
import { goToTop } from "common/helpers/common-utils";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutStepsSelector } from "layout/_redux/selectors";
import { Esponente } from "models/subject";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Anagrafica from "../_common-components/anagrafica";
import CarichePubbliche from "../_common-components/cariche-pubbliche";
import VerificaIdentita from "../_common-components/verifica-identita";
import InvitoModal from "./invito-modal";

const title = "3. Dati titolare effettivo";

const IdentificazioneTitolareEffettivo: React.FC = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const idPratica = useAppSelector(praticaIdPraticaSelector);
	const idCliente = useAppSelector(idClienteSelector);
	const subjects = useAppSelector(subjectSubjectsSelector);
	const titolariEffettiviStored = useAppSelector(titolariEffettiviAddedSelector);
	const elencoTitolariEffettivi = useAppSelector(elencoTitolariEffettiviSelector);

	const layoutSteps = useAppSelector(layoutStepsSelector);

	const location = useLocation();

	const activeAccordionIndex =
		(layoutSteps
			?.find((s) => s.route == AppRouterService.get(PathEnum.step3))
			?.subSteps?.findIndex((ss) => ss.route == location.pathname) || 0) + 1;

	const [titolariEffettiviList, setTitolariEffettiviList] = useState<Esponente[]>([]);
	const [originalNominative, setOriginalNominative] = useState<
		| {
				nome: string | undefined;
				cognome: string | undefined;
		  }
		| undefined
	>(undefined);

	const [currentTitolareEffettivo, setCurrentTitolareEffettivo] = useState<SoggettoDto | any>(
		() => {
			const elencoTitolariEffettiviArray = subjects?.elencoTitolariEffettivi || [];

			return elencoTitolariEffettiviArray.find((titolare) => !titolare.invitationRequest);
		}
	);

	const [showInvitationModal, setShowInvitationModal] = useState(false);
	const [showMessageModal, setShowMessageModal] = useState(false);
	const [email, setEmail] = useState("");

	const handleCloseInvitationModal = () => setShowInvitationModal(false);
	const handleShowInvitationModal = () => setShowInvitationModal(true);

	const handleCloseMessageModal = () => setShowMessageModal(false);
	const handleOpenMessageModal = () => setShowMessageModal(true);

	useEffect(() => {
		if (titolariEffettiviStored) {
			setTitolariEffettiviList(titolariEffettiviStored.list);

			if (location.pathname == AppRouterService.get(PathEnum.identificazioneTitolareEffettivo))
				navigate(AppRouterService.get(PathEnum.anagraficaTE), { replace: true });
		} else {
			navigate(AppRouterService.get(PathEnum.sceltaTitolareEffettivo), { replace: true });
		}
	}, []);

	useEffect(() => {
		const elencoTitolariEffettiviArray = subjects?.elencoTitolariEffettivi || [];

		const titolareEffettivo = elencoTitolariEffettiviArray.find(
			(titolare: SoggettoDto) =>
				titolare.fullfiled === false &&
				titolare.invitationRequest === false &&
				titolare.id === titolariEffettiviStored?.currentTitolareId
		);
		if (titolareEffettivo) {
			setCurrentTitolareEffettivo(titolareEffettivo);
			if (!originalNominative) {
				setOriginalNominative({ nome: titolareEffettivo.nome, cognome: titolareEffettivo.cognome });
			}
		}
	}, [elencoTitolariEffettivi]);

	const goNext = (route: string, email?: string) => {
		if (email) setEmail(email);

		navigate(route);
	};

	const handleBackSubStep = () => {
		navigate(-1);
	};

	const sendInvitation = (invitationData: any) => {
		if (!idPratica) return;

		if (
			!currentTitolareEffettivo.email ||
			currentTitolareEffettivo.email !== invitationData.email
		) {
			let subject: SoggettoDto = {
				...currentTitolareEffettivo,
				email: invitationData.email,
			};

			dispatch(subjectUpdateSubject({ subject }))
				.unwrap()
				.then((res) => {
					// console.log(res);
				});
		}

		const sendInvitationRequest: SendIvitationsRequest = {
			invitationRequestDto: {
				idPratica,
				idSoggetto: currentTitolareEffettivo.id,
				email: invitationData.email,
				reason: invitationData.reason,
			},
		};

		dispatch(subjectSendInvitation(sendInvitationRequest))
			.unwrap()
			.then((res) => {
				if (res) {
					handleCloseInvitationModal();
					handleOpenMessageModal();
				}
			});
	};

	const goToNextStep = () => {
		if (showMessageModal) {
			handleCloseMessageModal();
		}

		dispatch(subjectGetDetails())
			.unwrap()
			.then((res) => {
				if (res) {
					const elencoTitolariEffettiviArray = res?.elencoTitolariEffettivi || [];

					const updatedSubject = elencoTitolariEffettiviArray.find(
						(el) => el.id === currentTitolareEffettivo.id
					);
					const subjectFromListIndex = titolariEffettiviList.findIndex(
						(el) =>
							el.nome === originalNominative?.nome && el.cognome === originalNominative?.cognome
					);

					if (updatedSubject && subjectFromListIndex !== -1) {
						const updatedTitolariEffettiviList = [...titolariEffettiviList];

						updatedTitolariEffettiviList[subjectFromListIndex] = {
							...updatedTitolariEffettiviList[subjectFromListIndex],
							fulfilled: updatedSubject.fullfiled,
							invitationRequest: updatedSubject.invitationRequest,
							id: updatedSubject.id,
						};

						setTitolariEffettiviList(updatedTitolariEffettiviList);

						dispatch(
							subjectSetTitolariEffettiviAdded({
								list: updatedTitolariEffettiviList,
							})
						);
					}
					const updatedTitolariEffettiviList = [...titolariEffettiviList];

					if (
						updatedTitolariEffettiviList.some(
							(titolare) =>
								titolare.fulfilled === false &&
								titolare.invitationRequest === false &&
								titolare.rejected === false
						)
					) {
						navigate(AppRouterService.get(PathEnum.sceltaTitolareEffettivo));
					} else {
						navigate(AppRouterService.get(PathEnum.step4));
						// dispatch(layoutGoNext({ currentSubStepId: SubStepsEnum.LAST_SUBSTEP }));
					}
				}
			});
	};

	const getMessageOK = () => {
		return (
			<>
				Non appena{" "}
				<span className="font-weigth-bold m-0">{`${currentTitolareEffettivo?.nome} ${currentTitolareEffettivo?.cognome} `}</span>
				terminerà di caricare i suoi dati, sarai avvisato a mezzo e-mail. <br />
				Ti ricordo che anche tu potrai procedere alla compilazione delle pagine dedicate al Titolare
				Effettivo collegandoti al link della mail appena ricevuta.
			</>
		);
	};

	useEffect(() => {
		setTimeout(() => {
			const id = activeAccordionIndex > 1 ? `accordion-${activeAccordionIndex}` : null;
			goToTop(id);
		}, 300);
	}, [activeAccordionIndex]);

	return (
		<>
			<h2 className="mb-3 ms-3">{title}</h2>

			<div>
				<span className="gray">
					Qualora tu <b>non abbia evidenza o non possa verificare in modo certo</b> i dati sotto
					indicati e/o{" "}
					<b>non disponga altresì della scansione dei documenti identificativi richiesti</b>, puoi
					inoltrare un' e-mail al Titolare Effettivo affinchè possa controllare/completare i campi
					relativi alla sua anagrafica.
				</span>
				<div className="d-flex  mx-3 my-4">
					<BftButton className="btn-buffetti" onClick={handleShowInvitationModal}>
						Manda un invito
					</BftButton>
				</div>
			</div>

			{/* Anagrafica */}
			<BftAccordion
				title="Anagrafica"
				index={1}
				total={3}
				isActive={location.pathname === AppRouterService.get(PathEnum.anagraficaTE)}
				isCompleted={activeAccordionIndex > 6}
			>
				<Anagrafica
					subjectDetails={currentTitolareEffettivo}
					idCliente={idCliente}
					idPratica={idPratica}
					onComplete={(value) =>
						goNext(AppRouterService.get(PathEnum.ulterioriInformazioniTE), value)
					}
				/>
			</BftAccordion>

			{/* Cariche pubbliche */}
			<BftAccordion
				title="Cariche pubbliche"
				index={2}
				total={3}
				isActive={location.pathname === AppRouterService.get(PathEnum.ulterioriInformazioniTE)}
				isCompleted={activeAccordionIndex > 7}
				disabled={activeAccordionIndex < 7}
			>
				<CarichePubbliche
					subjectDetails={currentTitolareEffettivo}
					idCliente={idCliente}
					idPratica={idPratica}
					onComplete={() => goNext(AppRouterService.get(PathEnum.verificaIdentitaTE))}
				/>
			</BftAccordion>

			{/* Verifica la tua identità */}
			<BftAccordion
				title="Verifica la tua identità"
				index={3}
				total={3}
				isActive={location.pathname === AppRouterService.get(PathEnum.verificaIdentitaTE)}
				isCompleted={activeAccordionIndex > 8}
				disabled={activeAccordionIndex < 8}
			>
				<VerificaIdentita
					subjectDetails={currentTitolareEffettivo}
					idCliente={idCliente}
					idPratica={idPratica}
					onComplete={(value) => goNext(AppRouterService.get(PathEnum.completeTE), value)}
				/>
			</BftAccordion>

			<Row className="justify-content-between mx-3">
				<Col xs={1} className="p-0">
					<BftButton className="btn-buffetti-secondary ms-0 px-3" onClick={handleBackSubStep}>
						<i className="fas fa-arrow-left"></i>
					</BftButton>
				</Col>
				<Col xs={10} md={11} className="pe-0">
					<BftButton
						className="btn-buffetti col-12"
						isDisabled={activeAccordionIndex <= 8}
						onClick={goToNextStep}
					>
						Vai allo step successivo
					</BftButton>
				</Col>
			</Row>
			<InvitoModal
				show={showInvitationModal}
				onClose={handleCloseInvitationModal}
				onConfirm={(e: any) => sendInvitation(e)}
				email={email}
			/>
			<MessageModal
				show={showMessageModal}
				onClose={goToNextStep}
				message={getMessageOK()}
				footerMessage={"Prosegui con la compilazione"}
				title="L'invito è stato inviato"
				centered={false}
			/>
		</>
	);
};

export default IdentificazioneTitolareEffettivo;
